Cookies.remove('tea_purpose');
Cookies.remove('favorite_tea');
Cookies.remove('caffeine_level');
Cookies.remove('take-quiz');
Cookies.remove('has-answers');

$('.learn-more').on('click', function(e) {
    e.preventDefault();
    var height = $('.header-tools-wrapper').outerHeight();
    var href = $(this).attr('href');
    var pos = $(href).offset().top - (height);

    $('html, body').animate({
        scrollTop: pos + 'px'
    }, 800);
});

$(document).ready( function () {
    var $form = $('#subscribeForm');
    if($form.length > 0) {
        $('#subscribeForm input[type="submit"]').bind('click', function ( event ) {
            if(event) event.preventDefault();
            register($form);
        });
    }

    // $('.kickstarter-wrapper').addClass('active');
    // $('.kickstarter-wrapper .close').on('click', function() {
    //     $('.kickstarter-wrapper').removeClass('active').hide();
    // });

    resize();
});

$(window).resize(function() {
    resize();
});

function resize() {
    $('.step .info, .benefit.large .content').each(function() {
        var height = $(this).height();
        var margin = (height / 2) * (-1);
        $(this).css({
            'margin-top': margin + 'px',
        });
    });
}

function register($form) {
    $.ajax({
        type: $form.attr('method'),
        url: $form.attr('action'),
        data: $form.serialize(),
        cache       : false,
        dataType    : 'json',
        contentType: "application/json; charset=utf-8",
        error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
        success     : function(data) {
            if(data.result != "success") {
                // Something went wrong, alert(data.msg);
                var error = data.msg;
                var message;
                if (error === '0 - Please enter a value') {
                    message = 'Please enter an email.';
                } else if (error.indexOf('subscribed') >= 0) {
                    message = 'This email has been subscribed to the list already.';
                } else if (error.indexOf('single') >= 0) {
                    message = 'Please enter a correct email.';
                } else if (error.indexOf('looks fake or invalid') !== -1) {
                    message = 'Please try another email address.';
                }
                $('.subscribe-message .message').html(message);
                $('.subscribe-message-wrapper').addClass('active');
                setTimeout("$('.subscribe-message-wrapper').removeClass('active');", 2500);
            } else {
                // Success
                $('.subscribe-message .message').html('You are in! Please click the link in your email to confirm your subscription.');
                $('.subscribe-message-wrapper').addClass('active');
                setTimeout("$('.subscribe-message-wrapper').removeClass('active');", 3500);

                setTimeout(function() {
                  hideEmailModal();
                }, 4000);
            }
        }
    });
}
